<template>
  <div>
    <btn
      class="quick-add-drawer-trigger is-desktop"
      modifiers="primary fill dark center"
      :label="$string('quick_add.trigger_label')"
      type="button"
      @click.prevent="setQuickAddProduct"
    />
    <button
      type="button"
      class="quick-add-drawer-trigger--mobile is-mobile"
      :aria-label="$string('quick_add.trigger_label')"
      @click.prevent="setQuickAddProduct"
    >
      <icon-plus />
    </button>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import Btn from '~global/btn/btn'
import IconPlus from '~icons/directional-navigation/plus.svg'
import { formatEcommerceEvent, track } from '~/helpers/datalayer-actions'

export default {
  name: 'QuickAddDrawerTrigger',

  components: {
    Btn,
    IconPlus,
  },

  props: {
    product: {
      type: [Boolean, Object],
      default: null,
    },
    variant: {
      type: Object,
      default: null,
    },
    uid: {
      type: String,
      default: '',
    },
  },

  methods: {
    /**
     * Map Vuex actions.
     */
    ...mapActions({
      openOverlay: 'overlays/open',
      setProduct: 'quick-add/setProduct',
      setUID: 'quick-add/setUID',
    }),

    /**
     * Set quick add product to prop product, fire event.
     */
    setQuickAddProduct(event) {
      event.stopPropagation()

      // For the product card to send algolia conversions
      this.setUID(this.uid)

      this.setProduct(this.product)
      this.openOverlay({
        component: 'quick-add-drawer',
        ignoreDismissed: true,
        namespace: 'quickAddDrawer',
      })

      // Track click
      track({
        event: 'quick_add_cta_clicked',
        ...formatEcommerceEvent({
          variant: this.variant,
          product: this.product,
        }),
      })
    },
  },
}
</script>

<style lang="scss">
@import './quick-add-drawer-trigger';
</style>
